export default __webpack_public_path__ + "static/media/account-icon.8bb507bf.svg";